import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApplication, IFicheExpressionBesoinRequest, IFicheExpressionBesoinResponse } from 'src/app/shared/models/fiche-expression-besoin';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FicheExpressionBesoinService {

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private currentUserService: CurrentUserService
  ) {}

  // ── Headers d'audit ───────────────────────────────────────────────────────

  private createAuditHeaders(): HttpHeaders {
    const currentUser = this.currentUserService.getCurrentUser() as any || {};

    const requestId = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

    const role = currentUser?.role ?? '';
    const displayName = currentUser.displayName
      ?? `${currentUser.firstName ?? ''} ${currentUser.lastName ?? ''}`.trim();

    return new HttpHeaders({
      'Content-Type':              'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-User-Identifier':         currentUser.identifier ?? '',
      'X-User-Display-Name':       displayName,
      'X-User-Role':               role,
      'X-Actor-Source':            'FE',
      'X-Request-ID':              requestId
    });
  }

  private get options() {
    return { headers: this.createAuditHeaders() };
  }


  getAll(): Observable<IFicheExpressionBesoinResponse[]> {
    return this.http.get<IFicheExpressionBesoinResponse[]>(
      `${environment.backendApiUrl}/febs`, this.options);
  }

  getById(id: string): Observable<IFicheExpressionBesoinResponse> {
    return this.http.get<IFicheExpressionBesoinResponse>(
      `${environment.backendApiUrl}/febs/${id}`, this.options);
  }

  getByDemandeur(demandeurId: string): Observable<IFicheExpressionBesoinResponse[]> {
    return this.http.get<IFicheExpressionBesoinResponse[]>(
      `${environment.backendApiUrl}/febs/by-demandeur/${demandeurId}`, this.options);
  }

  getByApplications(applications: IApplication[]): Observable<IFicheExpressionBesoinResponse[]> {
    return this.http.post<IFicheExpressionBesoinResponse[]>(
      `${environment.backendApiUrl}/febs/by-applications`,
      { applications },
      this.options);
  }

  getByApplicationsAndStatusNotEqual(applications: IApplication[],status : string): Observable<IFicheExpressionBesoinResponse[]> {
    return this.http.post<IFicheExpressionBesoinResponse[]>(
      `${environment.backendApiUrl}/febs/by-applications/status-not-equal/${status}`,
      { applications},
      this.options);
  }

  create(feb: IFicheExpressionBesoinRequest): Observable<IFicheExpressionBesoinResponse> {
    return this.http.post<IFicheExpressionBesoinResponse>(
      `${environment.backendApiUrl}/febs`, feb, this.options);
  }


  duplicate(
  febId: string
): Observable<IFicheExpressionBesoinResponse> {

  return this.http.post<IFicheExpressionBesoinResponse>(
    `${environment.backendApiUrl}/febs/${febId}/duplicate`,
    null,
    this.options
  );
}

  update(id: string, feb: IFicheExpressionBesoinRequest): Observable<IFicheExpressionBesoinResponse> {
    return this.http.put<IFicheExpressionBesoinResponse>(
      `${environment.backendApiUrl}/febs/${id}`, feb, this.options);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.backendApiUrl}/febs/${id}`, this.options);
  }

  envoyerAuCds(id: string): Observable<IFicheExpressionBesoinResponse> {
    return this.http.post<IFicheExpressionBesoinResponse>(
      `${environment.backendApiUrl}/febs/${id}/envoyer-au-cdc`, {}, this.options);
  }

  exportFebData(febIds: string[]): Observable<Blob> {
    return this.http.post(
      `${environment.backendApiUrl}/febs/export/`,
      { febIds },
      { ...this.options, responseType: 'blob' });
  }
}